import { render, staticRenderFns } from "./unauth.vue?vue&type=template&id=6ac8c3f1&scoped=true&"
import script from "./unauth.vue?vue&type=script&lang=js&"
export * from "./unauth.vue?vue&type=script&lang=js&"
import style0 from "./unauth.vue?vue&type=style&index=0&id=6ac8c3f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac8c3f1",
  null
  
)

export default component.exports